import { Box } from "@mui/system";
import React, { useContext, useEffect } from "react";
import { theme } from "../../styles/theme";
import { NavigationDock } from "../../components/navigationDock";
import { Header } from "../../components/header";
import { LicenseIcon } from "../../svgIcons/icons";
import GroupIcon from "@mui/icons-material/Group";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { startDemo, userDetails } from "../../api/controllers/userController";
import { HttpStatusCode } from "axios";
import { ApplicationContext } from "../../context/application_ctx";
import { GlobalSnackBar } from "../../components/snackBar";
import { Licence } from "../licence";
import { ModuleType } from "../../constants";
import WelcomeDialog from "../../components/dialog/welcomeDialog";
import { UserProfileDetail } from "../userProfileDetail";
import { OrganisationProfileDetail } from "../organisationProfileDetail";
import { OrganisationDashboard } from "../organisationDashboard";
import { useLocation, useNavigate } from "react-router-dom";
import { GlobalLoaders } from "../../components/loaders/globalLoader";
import { PlanExpiryDialog } from "../../components/planExpiryDialog";
import {
  getAssignAdmin,
  getAudit,
  getLicencBatch,
  getPayment,
} from "../../api/controllers/dashboardController";
import { getUploadCVS } from "../../api/controllers/registeredUserController";
import { TableReadOnly } from "../userOnBoarding/tableReadOnly";
import DashboardIcon from "@mui/icons-material/Dashboard";
import BadgeIcon from "@mui/icons-material/Badge";
import { RepresentativeDetail } from "../representativeDetails";
import { Drawer } from "@mui/material";
export const DashBoard = () => {
  // context
  const {
    reloadProfile,
    globalLoader,
    setGlobalLoader,
    profileDetails,
    setProfileDetails,
    dashboardQuery,
    profileSnack,
    setProfileSnack,
    setError,
    error,
    activeTab,
    setActiveTab,
    setLicenceBatchList,
    licenceBatchList,
    setFilteredList,
    setEmployeesList,
    setAuditList,
    setPaymentList,
    setAssignDetails,
    dockMenu,
    setDockMenu,
  } = useContext(ApplicationContext);
  // const [count, setCount] = useState(true);
  const navigate = useNavigate();

  // states
  // const [activeTab, setActiveTab] = useState(ModuleType?.onBoarding);
  // const [profileDetails, setProfileDetails] = useState({});
  // const [profileSnack, setProfileSnack] = useState(false);
  // const [expiryDialog, setExpiryDialog] = useState(false);
  // const [error, setError] = useState("");
  // const [subscriptionNav, setSubscriptionNav] = useState(false);

  // const dashboardQuery = useMediaQuery("(max-width:967px)");
  console.log(activeTab, "active page");

  let navItems = [
    {
      label: " Dashboard",
      icon: (
        <DashboardIcon
          sx={{
            color:
              activeTab === ModuleType?.organisationDashboard
                ? theme.col_2
                : theme.col_4,
            // fontSize: "33px",
          }}
          // activeTab={activeTab}
        />
      ),
    },
    {
      label: "Employee onboarding ",
      icon: (
        <BadgeIcon
          sx={{
            color:
              activeTab === ModuleType?.onBoarding ? theme.col_2 : theme.col_4,
            // fontSize: "33px",
          }}
          // activeTab={activeTab}
        />
      ),
    },
    // {
    //   label: "Profile",
    //   icon: (
    //     <AccountCircleIcon
    //       sx={{
    //         color: activeTab === ModuleType?.profile ? theme.col_2 : theme.col_4,
    //         // fontSize: "33px",
    //       }}
    //     // activeTab={activeTab}
    //     />
    //   ),
    // },
    {
      label: "Licence",
      icon: (
        <LicenseIcon
          // sx={{
          //   color: activeTab === ModuleType?.licence ? theme.col_2 : theme.col_4,
          //   fontSize: "33px",
          // }}
          fontSize={32}
          activeTab={activeTab}
        />
      ),
    },
    // {
    //   label: "Audit",
    //   icon: (
    //     <LicenseIcon
    //       // sx={{
    //       //   color: activeTab === ModuleType?.licence ? theme.col_2 : theme.col_4,
    //       //   fontSize: "33px",
    //       // }}
    //       fontSize={32}
    //       activeTab={activeTab}
    //     />
    //   ),
    // },
    {
      label: "User Profile",
      icon: (
        <AccountCircleIcon
          sx={{
            color:
              activeTab === ModuleType?.userProfile ? theme.col_2 : theme.col_4,
            // fontSize: "33px",
          }}
          // activeTab={activeTab}
        />
      ),
    },
    {
      label: "Company Profile",
      icon: (
        <GroupIcon
          sx={{
            color:
              activeTab === ModuleType?.organisationProfile
                ? theme.col_2
                : theme.col_4,
            // fontSize: "33px",
          }}
          // activeTab={activeTab}
        />
      ),
    },

    // {
    //   label: "Users",
    //   icon: (
    //     <PersonIcon
    //       sx={{
    //         color: activeTab === 3 ? theme.col_2 : theme.col_4,
    //         fontSize: "33px",
    //       }}
    //       activeTab={activeTab}
    //     />
    //   ),
    // },
  ];
  let path = [
    "dashboard",
    "employee-onboarding",
    "licence",
    "user-profile",
    "company-profile",
    "representative-profile",
  ];

  let count = 0;
  const apiSubscribeDemo = async (type) => {
    count += 1;
    console.log(count, "countt");
    if (count === 1) {
      try {
        let response = await startDemo({
          licenseCount: 20,
        });
        console.log(response, "responseLogin");
        if (response.status === HttpStatusCode.Ok) {
          let responseDetail = await getLicencBatch();

          setLicenceBatchList(responseDetail.data);
          setGlobalLoader(false);
        }
        if (response.status === HttpStatusCode.BadRequest) {
          setGlobalLoader(false);

          setError(response.data.message);
          setProfileSnack(true);
          // setSignInSnack(true);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };
  useEffect(() => {
    let location = window.location.pathname.split("/")[2];
    setActiveTab(path.indexOf(location));
    console.log(location, "locc");
    if (!localStorage.getItem("api-token")) {
      navigate("/signin");
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    console.log(count, "count");

    const getDetails = async () => {
      try {
        let response = await userDetails();
        setGlobalLoader(true);
        console.log(response, "responseLogin");
        if (response.status === HttpStatusCode.Ok) {
          console.log(count, "countt");
          if (!response.data.isOnDemo) {
            apiSubscribeDemo();
          }

          setProfileDetails(response.data);
          console.log(response.data._id, "iddddddddddd");
          // setError(response.data.message);
          // setSignInSnack(true);
          // setTimeout(() => {
          //   setSignInSnack(false);
          // }, 3000);
        }
        if (response.status === HttpStatusCode.Unauthorized) {
          navigate("/signin");
        }
      } catch (error) {
        console.log(error);
      }
    };
    getDetails();
    
  }, []);// eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    // setCount(count + 1)
    const getDetails = async () => {
      try {
        let response = await userDetails();
        setGlobalLoader(true);
        console.log(response, "responseLogin");
        if (response.status === HttpStatusCode.Ok) {
          console.log(count, "countt");

          setProfileDetails(response.data);
          console.log(response.data._id, "iddddddddddd");
          payments(response.data._id);
          // setError(response.data.message);
          // setSignInSnack(true);
          // setTimeout(() => {
          //   setSignInSnack(false);
          // }, 3000);
        }
        if (response.status === HttpStatusCode.Unauthorized) {
          navigate("/signin");
        }
      } catch (error) {
        console.log(error);
      }
    };
    const payments = async (id) => {
      setGlobalLoader(true);

      try {
        let response = await getPayment(id);
        console.log(response, "getEmployees");
        if (response.status === HttpStatusCode.Ok) {
          setTimeout(() => {
            setGlobalLoader(false);
          }, 2000);
          setPaymentList(response?.data?.payments);
          // setFilteredList(response.data);
        }
        if (response.status === HttpStatusCode.Unauthorized) {
          navigate("/signin");
        }

        // setEmployeesData(response.data);
      } catch (error) {
        console.log(error);
      }
    };
    const batches = async () => {
      try {
        let response = await getLicencBatch();
        console.log(response, "getEmployees");
        if (response.status === HttpStatusCode.Ok) {
          //  let demoDateExpiration = dayjs(response?.data[0]?.expirationDate).format("YYYY-MM-DD")
          //  let demoDatePurchase = dayjs(new Date()).format("YYYY-MM-DD")
          //  let finalDateDemo = dayjs(demoDateExpiration).diff(dayjs(demoDatePurchase),'days')

          //  let standardDateExpiration = dayjs(response?.data[response?.data?.length - 1]?.expirationDate).format("YYYY-MM-DD")
          //  let standardDatePurchase = dayjs(new Date()).format("YYYY-MM-DD")
          //  let finalDateStandard = dayjs(standardDateExpiration).diff(dayjs(standardDatePurchase),'days')
          //  console.log(finalDateDemo,finalDateStandard,'datefinal')
          //   if (
          //   ( finalDateDemo < 10 ) ||
          //     (finalDateStandard < 10 && response.data.length > 1)
          //   ) {
          //     setExpiryDialog(true);
          //   }
          setTimeout(() => {
            setGlobalLoader(false);
          }, 2000);
          // setEmployeesList(response.data);
          // setFilteredList(response.data);
          setLicenceBatchList(response.data);
        }
        if (response.status === HttpStatusCode.Unauthorized) {
          navigate("/signin");
        }
        // setEmployeesData(response.data);
      } catch (error) {
        console.log(error);
      }
    };

    const getEmployees = async () => {
      setGlobalLoader(true);

      try {
        let response = await getUploadCVS();
        console.log(response, "getEmployees");
        if (response.status === HttpStatusCode.Ok) {
          setTimeout(() => {
            setGlobalLoader(false);
          }, 2000);
          setEmployeesList(response.data);
          setFilteredList(response.data);
        }
        if (response.status === HttpStatusCode.Unauthorized) {
          navigate("/signin");
        }

        // setEmployeesData(response.data);
      } catch (error) {
        console.log(error);
      }
    };
    const audit = async () => {
      setGlobalLoader(true);

      try {
        let response = await getAudit();
        console.log(response, "getAudit");
        if (response.status === HttpStatusCode.Ok) {
          setTimeout(() => {
            setGlobalLoader(false);
          }, 2000);
          setAuditList(response.data?.auditLogs);
          // setFilteredList(response.data);
        }
        if (response.status === HttpStatusCode.Unauthorized) {
          navigate("/signin");
        }

        // setEmployeesData(response.data);
      } catch (error) {
        console.log(error);
      }
    };

    const assignedAdmin = async (id) => {
      setGlobalLoader(true);

      try {
        let response = await getAssignAdmin();
        console.log(response, "getAssignees");
        if (response.status === HttpStatusCode.Ok) {
          setTimeout(() => {
            setGlobalLoader(false);
          }, 2000);
          setAssignDetails(response?.data);
          // setFilteredList(response.data);
        }
        if (response.status === HttpStatusCode.Unauthorized) {
          navigate("/signin");
        }

        // setEmployeesData(response.data);
      } catch (error) {
        console.log(error);
      }
    };
    // payments()
    assignedAdmin();
    audit();
    getEmployees();
    getDetails();
    batches();
  }, [reloadProfile]); // eslint-disable-line react-hooks/exhaustive-deps

  // const handleClose = () => {
  //   setSubDialog(false);
  //   setSubscriptionNav(false);
  // };
  return (
    <>
      <Box display="flex" width="100vw" height="100vh">
        {dashboardQuery ? (
          <></>
        ) : (
          <NavigationDock setDockMenu={setDockMenu} navItems={navItems} />
        )}
        <Box
          display="flex"
          width={dashboardQuery ? "100%" : "88%"}
          height="100%"
          justifyContent="center"
          backgroundColor={theme.col_7}
          position="relative"
        >
          {globalLoader ? <GlobalLoaders /> : <></>}

          <Box
            flex="1"
            display="flex"
            // position="relative"
            flexDirection="column"
            gap={2}
            padding={dashboardQuery ? "10px" : "0px 95px"}
            paddingBottom={dashboardQuery ? "60px" : "30px"}
            overflow="auto"
            sx={{ overflowX: "hidden" }}
          >
            <Header
              setDockMenu={setDockMenu}
              activeTab={activeTab}
              setActiveTab={setActiveTab}
              dashboardQuery={dashboardQuery}
            />
            <ActiveModule
              setProfileDetails={setProfileDetails}
              profileDetails={profileDetails}
              dashboardQuery={dashboardQuery}
              activeTab={activeTab}
            />
          </Box>
          {/* {dashboardQuery ? <BottomNavBar navItems={navItems} /> : <></>} */}
        </Box>
      </Box>
      {/* Side Dock */}
      <Drawer open={dockMenu && dashboardQuery} onClose={() => setDockMenu(false)} >
        <NavigationDock
          setDockMenu={setDockMenu}
          dashboardQuery={dashboardQuery}
          navItems={navItems}
        />
      </Drawer>
      <PlanExpiryDialog
        licenceBatchList={licenceBatchList}
        profileDetails={profileDetails}
        upgrade={true}
        demoExpired={true}
      />
      <WelcomeDialog />
      <GlobalSnackBar
        open={profileSnack}
        title={error}
        close={setProfileSnack}
      />
    </>
  );
};

export const ActiveModule = ({
  activeTab,
  setProfileDetails,
  profileDetails,
}) => {
  const location = useLocation();
  console.log();
  switch (location.pathname) {
    case "/dashboard":
      return <OrganisationDashboard />;
    // return null;

    case "/employee-onboarding":
      return <TableReadOnly />;
    // return <OnBoardingTable />

    // case ModuleType.profile:
    //   return <Profile />
    //   return null;

    case "/user-profile":
      return <UserProfileDetail />;

    case "/licence":
      return (
        <Licence
          setProfileDetails={setProfileDetails}
          profileDetails={profileDetails}
        />
      );

    // case ModuleType.audit:
    //   return (
    //     <Audit
    //       setProfileDetails={setProfileDetails}
    //       profileDetails={profileDetails}
    //     />
    //   );
    case "/company-profile":
      return <OrganisationProfileDetail />;

    case "/representative-profile":
      return <RepresentativeDetail />;

    default:
      return;
  }
};
